/**
 * Imports the Freighthub API.
 */
import { api } from '../api.js';

export default {
    /**
     * GET api.freighthub.nz/carrier/gps/schedule-monitor/truck-running-schedules
     */
    get: function( params ){
        return api.get( '/carrier/gps/schedule-monitor/truck-running-schedules' , { params: params } );
    },

    /**
     * DELETE
     */
    delete: function( scheduleId ){
        return api.delete( '/carrier/gps/schedule-monitor/truck-running-schedules/' + scheduleId );
    },

    /**
     * PUT '/carrier/gps/schedule-monitor/truck-running-schedules/{truck-running-schedules}
     */
    put: function( { id, placeOriginId, placeDestinationId, std, sta, staAddDays, daysOfWeek, truckIds, contractorId, name } ){
        return api.put( '/carrier/gps/schedule-monitor/truck-running-schedules/' + id,
            {
                name: name,
                place_origin_id: placeOriginId,
                place_destination_id: placeDestinationId,
                std: std,
                sta: sta,
                sta_add_days: staAddDays,
                days_of_week: daysOfWeek,
                truck_ids: truckIds,
                contractor_id: contractorId,
            }
        );
    },

    /**
     * POST '/carrier/gps/schedule-monitor/truck-running-schedules
     */
    post: function( { placeOriginId, placeDestinationId, std, sta, staAddDays, daysOfWeek, truckIds, contractorId, name} ){
        return api.post( '/carrier/gps/schedule-monitor/truck-running-schedules/',
            {
                place_origin_id: placeOriginId,
                place_destination_id: placeDestinationId,
                std: std,
                sta: sta,
                sta_add_days: staAddDays,
                days_of_week: daysOfWeek,
                truck_ids: truckIds,
                contractor_id: contractorId,
                name: name,
            }
        );
    },
}